import React, { useEffect } from "react";
import admission_pic_1 from "../../../assets/img/admission/admission_1.jpg";
import admission_pic_2 from "../../../assets/img/admission/admission_2.jpg";
import session_26_27 from "../../../assets/img/admission/session_26_27.jpeg";
import { Link } from "react-router-dom";
import Meta from "../../meta/Meta";

const AdmissionNews = () => {
  const pageDescription = "Check out the latest news on school admission.";
  const pageImage = "https://i.ibb.co/gwkTRWk/new-School.png";
  const pageUrl = "https://almaghribschool.com/admission/news";
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Admission | Al-Maghrib";
  }, []);
  return (
    <>
      <Meta
        pageTitle={"Admission | Al-Maghrib"}
        pageDescription={pageDescription}
        pageImage={pageImage}
        pageUrl={pageUrl}
      />
      <div>
        <div
          className="relative pt-16 pb-32 flex content-center items-center justify-center"
          style={{
            minHeight: "45vh",
          }}
        >
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
               `url(${session_26_27})`
            }}
          >
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-75 bg-black"
            ></span>
          </div>
          <div className="container relative mx-auto">
            <div className="items-center flex flex-wrap">
              <div className="w-full px-2 md:px-4 ml-auto mr-auto text-center">
                <div className="">
                  <h1 className="text-white font-semibold text-4xl md:text-5xl">
                    Admission is Running for Session 2026 - 2027
                  </h1>
                  <p className="mt-4 text-lg text-gray-300">
                    <strong>Visit Our Campus for More Information</strong>{" "}
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="pt-20 pb-20 bg-blue-50 -mt-24">
          <div className="container mx-auto px-4 mt-5">
            <div className=" py-10 ">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* card 1 */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
                <img
                  src={session_26_27}
                  alt="Admission"
                  className="w-full object-cover"
                />
              </div>

              {/* Card 2 */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
                <img
                  src={session_26_27}
                  alt="Admission"
                  className="w-full h-56 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                    Admission Open at Al-Maghrib International School
                  </h3>
                  <p className="text-gray-700 dark:text-gray-400 space-y-2  leading-relaxed">
                    <span>Session 2026 - 2027</span>
                    <br />
                    <span>For Classes:</span>
                    <br />
                    <span>• EYFS – Playgroup, Nursery & Reception (KG)</span>
                    <br />
                    <span>• Year 01 – Year 04</span>
                    <br />
                    <span>
                      • Full-time Hifz Department with Cambridge Curriculum
                    </span>
                    <br />
                    <span>
                      Admission forms are available during office hours:
                    </span>
                    <br />
                    <span>• Sunday–Thursday: 9:00 AM – 4:00 PM</span>
                  </p>
                </div>
              </div>

            </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdmissionNews;
